import { useState, useEffect } from "react";
import API from "../Context/api";
import ErrorMessage from "../Helpers/ErrorMessage";

function EditReceiptForm({ id, setIsModalOpen, onReceiptUpdated }) {
  const [customer, setCustomer] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [chequeNo, setChequeNo] = useState("");
  const [balance, setBalance] = useState("");
  const [amountInWords, setAmountInWords] = useState("");
  const [paymentfor, setPaymentfor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  console.log(id);

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const response = await API.get(`/receipts/${id}`);
        const receipt = response.data;

        setCustomer(receipt.receiptDetails.client);
        setTotalAmount(receipt.receiptDetails.totalAmount.toString());
        setChequeNo(receipt.receiptDetails.chequeNo || "");
        setBalance(receipt.receiptDetails.balance.toString());
        setAmountInWords(receipt.receiptDetails.amountInWords);
        setPaymentfor(receipt.receiptDetails.paymentfor);
      } catch (error) {
        console.error("Error fetching receipt:", error);
        alert("Failed to load receipt data");
        const errorMsg =
          error.response?.data?.message || "Failed to update computer";
        setErrorMessage(errorMsg);
      }
    };

    fetchReceipt();
  }, [id]);

  const updateReceipt = async () => {
    if (!customer.trim() || !totalAmount) {
      alert("Please add a customer name and total amount.");
      return;
    }

    const updatedData = {
      receiptDetails: {
        client: customer,
        totalAmount: parseFloat(totalAmount),
        chequeNo: chequeNo,
        balance: parseFloat(balance || 0),
        amountInWords: amountInWords,
        paymentfor: paymentfor,
      },
    };

    try {
      await API.put(`/receipts/${id}`, updatedData);
      onReceiptUpdated();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error updating receipt:", error);
      alert(`Failed to update receipt: ${error.message || "Unknown error"}`);
    }
  };

  return (
    // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
    //   <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
    //     <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto">
    //       <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
    //         Edit Receipt
    //       </h2>

    //       {/* Customer Name and Receipt Inputs */}
    //       <div className="mb-4">
    //         <label
    //           className="block text-gray-700 text-sm mb-2"
    //           htmlFor="customer-name"
    //         >
    //           Customer Name
    //         </label>
    //         <input
    //           id="customer-name"
    //           type="text"
    //           className="border border-gray-300 p-2 rounded w-full mb-2"
    //           placeholder="Customer Name"
    //           value={customer}
    //           onChange={(e) => setCustomer(e.target.value)}
    //         />

    //         <label
    //           className="block text-gray-700 text-sm mb-2"
    //           htmlFor="paymentfor"
    //         >
    //           Being Payment For
    //         </label>
    //         <input
    //           id="paymentfor"
    //           type="text"
    //           className="border border-gray-300 p-2 rounded w-full mb-2"
    //           placeholder="Being Payment For"
    //           value={paymentfor}
    //           onChange={(e) => setPaymentfor(e.target.value)}
    //         />
    //         <label
    //           className="block text-gray-700 text-sm mb-2"
    //           htmlFor="total-amount"
    //         >
    //           Total Amount (UGX)
    //         </label>
    //         <input
    //           id="total-amount"
    //           type="number"
    //           className="border border-gray-300 p-2 rounded w-full mb-2"
    //           placeholder="Total Amount (UGX)"
    //           value={totalAmount}
    //           onChange={(e) => setTotalAmount(e.target.value)}
    //         />

    //         <label
    //           className="block text-gray-700 text-sm mb-2"
    //           htmlFor="amountInWords"
    //         >
    //           Amount In Words
    //         </label>
    //         <input
    //           type="text"
    //           id="amountInWords"
    //           className="border border-gray-300 p-2 rounded w-full my-2"
    //           placeholder="Amount in words"
    //           value={amountInWords}
    //           onChange={(e) => setAmountInWords(e.target.value)}
    //         />

    //         <label
    //           className="block text-gray-700 text-sm mb-2"
    //           htmlFor="cheque-no"
    //         >
    //           Cheque No (optional)
    //         </label>
    //         <input
    //           id="cheque-no"
    //           type="text"
    //           className="border border-gray-300 p-2 rounded w-full mb-2"
    //           placeholder="Cheque No (optional)"
    //           value={chequeNo}
    //           onChange={(e) => setChequeNo(e.target.value)}
    //         />

    //         <label
    //           className="block text-gray-700 text-sm mb-2"
    //           htmlFor="balance"
    //         >
    //           Balance (UGX, optional)
    //         </label>
    //         <input
    //           id="balance"
    //           type="number"
    //           className="border border-gray-300 p-2 rounded w-full mb-2"
    //           placeholder="Balance (UGX, optional)"
    //           value={balance}
    //           onChange={(e) => setBalance(e.target.value)}
    //         />
    //       </div>

    //       {/* Grand Total */}
    //       <div className="mt-4 text-right text-lg font-semibold">
    //         Total: UGX{" "}
    //         {totalAmount ? parseFloat(totalAmount).toLocaleString() : "0"}
    //       </div>

    //       {/* Buttons */}
    //       <div className="mt-4 flex justify-end space-x-2">
    //         <button
    //           onClick={updateReceipt}
    //           className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
    //         >
    //           Update Receipt
    //         </button>
    //         <button
    //           onClick={() => setIsModalOpen(false)}
    //           className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
    //         >
    //           Cancel
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </div>

    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
      <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col h-[90vh] sm:h-[80vh]">
        {/* Header */}
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">
            Edit Receipt
          </h2>
          <ErrorMessage message={errorMessage} />
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto px-4 py-2 space-y-4">
          {/* Customer Name and Receipt Inputs */}
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm mb-2"
              htmlFor="customer-name"
            >
              Customer Name
            </label>
            <input
              id="customer-name"
              type="text"
              className="border border-gray-300 p-2 rounded w-full mb-2"
              placeholder="Customer Name"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
            />

            <label
              className="block text-gray-700 text-sm mb-2"
              htmlFor="paymentfor"
            >
              Being Payment For
            </label>
            <input
              id="paymentfor"
              type="text"
              className="border border-gray-300 p-2 rounded w-full mb-2"
              placeholder="Being Payment For"
              value={paymentfor}
              onChange={(e) => setPaymentfor(e.target.value)}
            />
            <label
              className="block text-gray-700 text-sm mb-2"
              htmlFor="total-amount"
            >
              Total Amount (UGX)
            </label>
            <input
              id="total-amount"
              type="number"
              className="border border-gray-300 p-2 rounded w-full mb-2"
              placeholder="Total Amount (UGX)"
              value={totalAmount}
              onChange={(e) => setTotalAmount(e.target.value)}
            />

            <label
              className="block text-gray-700 text-sm mb-2"
              htmlFor="amountInWords"
            >
              Amount In Words
            </label>
            <input
              type="text"
              id="amountInWords"
              className="border border-gray-300 p-2 rounded w-full my-2"
              placeholder="Amount in words"
              value={amountInWords}
              onChange={(e) => setAmountInWords(e.target.value)}
            />

            <label
              className="block text-gray-700 text-sm mb-2"
              htmlFor="cheque-no"
            >
              Cheque No (optional)
            </label>
            <input
              id="cheque-no"
              type="text"
              className="border border-gray-300 p-2 rounded w-full mb-2"
              placeholder="Cheque No (optional)"
              value={chequeNo}
              onChange={(e) => setChequeNo(e.target.value)}
            />

            <label
              className="block text-gray-700 text-sm mb-2"
              htmlFor="balance"
            >
              Balance (UGX, optional)
            </label>
            <input
              id="balance"
              type="number"
              className="border border-gray-300 p-2 rounded w-full mb-2"
              placeholder="Balance (UGX, optional)"
              value={balance}
              onChange={(e) => setBalance(e.target.value)}
            />
          </div>

          {/* Grand Total */}
          <div className="mt-4 text-right text-lg font-semibold">
            Total: UGX{" "}
            {totalAmount ? parseFloat(totalAmount).toLocaleString() : "0"}
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="p-4 border-t border-gray-200 flex flex-col sm:flex-row justify-end gap-2">
          <button
            onClick={updateReceipt}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Update Receipt
          </button>
          <button
            onClick={() => setIsModalOpen(false)}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditReceiptForm;
